// extracted by mini-css-extract-plugin
export default {"footerContainer":"WarningFooter_footerContainer__Av6rw"};